"use strict";

const qaCheckCart = async () => {
  const res = await fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
    header: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }).then((response) => {
    return response.json();
  });

  return res;
};

const qaClearCart = async () => {
  const cleared = await fetch(window.Shopify.routes.root + "cart/clear.js", {
    header: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }).then((response) => {
    return response.json();
  });

  return cleared;
};

const qaAddItemsToCart = async (formData) => {
  const atcAction = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error("Error: ", error);
      return error;
    });

  return atcAction;
};

const handleQuickAdd = async (productId) => {
  // Override fbq temporarily to prevent duplicate events
  const originalFbq = window.fbq;
  let fbqCallCount = 0;

  if (typeof window.fbq !== "undefined") {
    window.fbq = function (...args) {
      if (args[0] === "track" && args[1] === "AddToCart") {
        fbqCallCount++;
        return; // Block the call
      }
      return originalFbq.apply(this, args);
    };
  }

  await qaClearCart();

  let localId = Math.floor(Math.random() * 1000000);

  // Kit size variant mappings for digital download and processing
  const kitMappings = {
    // 2 Items (Starter)
    31761789124682: {
      digitalDownload: "31761820811338", // Digital Download - 2 Items
      standardProcessing: "32546993897546", // Standard Processing Time - 2 Items
    },
    // 10 Items (Family)
    31761789157450: {
      digitalDownload: "31761820844106", // Digital Download - 5 Items
      standardProcessing: "32546995732554", // Standard Processing Time - 5 Items
    },
    // 20 Items (Closet)
    31761789190218: {
      digitalDownload: "31761820876874", // Digital Download - 10 Items
      standardProcessing: "32546996420682", // Standard Processing Time - 10 Items
    },
    // 40 Items (Trunk)
    31761789222986: {
      digitalDownload: "31761820909642", // Digital Download - 20 Items
      standardProcessing: "32546996781130", // Standard Processing Time - 20 Items
    },
  };

  const mapping = kitMappings[productId.toString()];

  const formData = {
    items: [
      // Main kit
      {
        id: productId.toString(),
        properties: {
          localId,
        },
        quantity: 1,
      },
      // Digital download for this kit size
      {
        id: mapping?.digitalDownload || "42069319581770", // Default to 2-item if not found
        properties: {
          localId,
        },
        quantity: 1,
      },
      // Standard processing for this kit size
      {
        id: mapping?.standardProcessing || "42069337833546", // Default to 2-item if not found
        properties: {
          localId,
        },
        quantity: 1,
      },
      // Cloud product
      {
        id: 42069346287690,
        properties: {
          localId,
        },
        quantity: 1,
        selling_plan: 3640262730,
      },
    ],
  };

  const addItems = await qaAddItemsToCart(formData);

  // Fire proper combined Facebook pixel event after successful cart add
  if (typeof window.fbq !== "undefined" && addItems && !addItems.message) {
    try {
      const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
      const cartData = await cartResponse.json();

      // Find the items we just added (they'll have the same localId)
      const addedItems = cartData.items.filter(
        (item) => item.properties && item.properties.localId === localId
      );

      if (addedItems.length > 0) {
        // Calculate total value from cart data
        const totalValue = addedItems.reduce((sum, item) => {
          return sum + item.final_price / 100;
        }, 0);

        // Get product IDs (not variant IDs)
        const contentIds = addedItems.map((item) => item.product_id.toString());

        // Create contents array with accurate pricing
        const contents = addedItems.map((item) => ({
          id: item.product_id.toString(),
          quantity: item.quantity,
          item_price: item.final_price / 100,
        }));

        // Find main product for naming
        const mainProduct = addedItems.find(
          (item) => item.product_type === "Main Product"
        );

        const pixelData = {
          currency: "USD",
          content_type: "product_group",
          content_ids: contentIds,
          contents: contents,
          value: totalValue,
          num_items: addedItems.length,
          content_name: mainProduct
            ? mainProduct.product_title
            : "Legacybox Kit Bundle",
          content_category: "Main Product",
        };

        // Temporarily restore original fbq to fire our event
        window.fbq = originalFbq;

        // Fire the Facebook pixel event
        window.fbq("track", "AddToCart", pixelData);
      }
    } catch (error) {
      // Restore original fbq even on error
      window.fbq = originalFbq;
    }
  } else {
    // Restore original fbq
    if (typeof window.fbq !== "undefined") {
      window.fbq = originalFbq;
    }
  }
};

const initQuickAdd = () => {
  // const convertTest = document.querySelector("[data-convert-test-qa]");

  // if (convertTest.getAttribute("false")) return;

  const quickAddBtns = document.querySelectorAll("[data-quick-add-product-id]");

  quickAddBtns.forEach((btn) => {
    const qaProductId = btn.getAttribute("data-quick-add-product-id");
    const productLink = btn.getAttribute("data-product-link");
    btn.addEventListener("click", async (event) => {
      event.preventDefault();
      const e = event.target;

      if (!e.classList.contains("js-quick-add-trigger")) {
        return (window.location.href = productLink);
      }

      const qaBtnText = btn.querySelector(
        ".quick-add__atc-btn > .js-quick-add-trigger"
      );
      const qaLoadingDots = btn.querySelector(".quick-add__loading");
      qaBtnText.style.display = "none";
      qaLoadingDots.style.display = "flex";
      await handleQuickAdd(qaProductId);
    });
  });
};

initQuickAdd();
